import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '../../common/enums/api-status';
import { createProposalAsync, deleteProposalAsync, deleteProposalsAsync, getDocumentProcessStatusAsync, getProposalsAsync } from './proposalThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const proposalSlice = createSlice({
    name: 'proposal',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProposalsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getProposalsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.allProposals = action.payload;
        })
            .addCase(getProposalsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteProposalAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteProposalAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.proposal = action.payload;
            if (state.allProposals) {
                state.allProposals = state.allProposals.filter((p) => p.id !== action.payload.id);
            }
        })
            .addCase(deleteProposalAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(deleteProposalsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            if (state.allProposals) {
                state.allProposals = state.allProposals.filter((p) => !action.payload.includes(p.id));
            }
        });
        builder
            .addCase(createProposalAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createProposalAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.proposal = action.payload;
            // Add the newly created proposal to the allProposals array
            if (state.allProposals) {
                state.allProposals = [action.payload, ...state.allProposals];
            }
            else {
                state.allProposals = [action.payload];
            }
        })
            .addCase(createProposalAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getDocumentProcessStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDocumentProcessStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.allProposals = action.payload;
        })
            .addCase(getDocumentProcessStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default proposalSlice.reducer;
